// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-profile-edit .new-profile-edit-layout .AddFileGroup {
  margin: 0 auto 20px;
  padding: 0;
  position: relative;
  width: fit-content;
}
.fi-profile-edit .new-profile-edit-layout .AddFileGroup .profile-edit-image {
  cursor: pointer;
}
.fi-profile-edit .new-profile-edit-layout .AddFileGroup .profile-edit-image .UserImage {
  position: relative;
  box-shadow: 0 3px 11px 2px #cdcdcd;
}
.fi-profile-edit .new-profile-edit-layout .AddFileGroup .profile-edit-image.locked-profile-icon.lockAfterCcmIcon:after {
  border-radius: 50%;
}
.fi-profile-edit .new-profile-edit-layout .AddFileGroup .profile-image-upload-icon {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  color: var(--fi-color-white);
  background-color: var(--fi-color-dark);
  box-shadow: 0 3px 11px 2px #cdcdcd;
  text-align: center;
  line-height: 150px;
  cursor: pointer;
  transition: all 0.2s;
}
.fi-profile-edit .new-profile-edit-layout .AddFileGroup .profile-image-upload-icon.square {
  border-radius: 10px;
}
.fi-profile-edit .new-profile-edit-layout .AddFileGroup .profile-image-upload-icon:hover {
  background-color: var(--fi-color-light);
}
.fi-profile-edit .new-profile-edit-layout .AddFileGroup .profile-image-upload-icon .mat-icon {
  vertical-align: middle;
  font-size: 60px;
  width: 100%;
  height: 60px;
}
.fi-profile-edit .new-profile-edit-layout .AddFileGroup .fi-profile-icon {
  position: relative;
}
.fi-profile-edit .new-profile-edit-layout .AddFileGroup .fi-profile-icon .fi-profile-icon-img {
  box-shadow: 0 3px 11px 2px #cdcdcd;
}
.fi-profile-edit .new-profile-edit-layout .AddFileGroup .light-overlay {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
  border-radius: 50%;
  background-color: transparent;
  transition: all 0.2s;
}
.fi-profile-edit .new-profile-edit-layout .AddFileGroup .light-overlay.shown {
  background-color: var(--fi-background-color-extra-ligt-transparent);
}
.fi-profile-edit .new-profile-edit-layout .AddFileGroup .light-overlay.square {
  border-radius: 10px;
}
.fi-profile-edit .new-profile-edit-layout .AddFileGroup .edit-profile-image-button {
  position: absolute;
  right: 0;
  bottom: 10px;
  border-radius: 50%;
  width: 30px;
  height: 30px;
  line-height: 15px;
  font-size: 18px;
}
.fi-profile-edit .new-profile-edit-layout .AddFileGroup .edit-profile-image-button .mat-icon {
  line-height: 30px;
}
.fi-profile-edit .new-profile-edit-layout .AddFileGroup .edit-profile-image-button.centered, .fi-profile-edit .new-profile-edit-layout .AddFileGroup .edit-profile-image-button.top-right {
  background-color: var(--fi-color-white);
  box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1019607843);
}
.fi-profile-edit .new-profile-edit-layout .AddFileGroup .edit-profile-image-button.top-right {
  top: 20px;
}
.fi-profile-edit .new-profile-edit-layout .AddFileGroup .edit-profile-image-button.centered {
  bottom: -12px;
  left: 50%;
  transform: translateX(-50%);
}
.fi-profile-edit .AddFileGroup .fi-profile-icon {
  vertical-align: middle;
}
.fi-profile-edit .AddFileGroup .fi-profile-icon.lockAfterCcmIcon:after {
  width: 160px;
}
.fi-profile-edit fi-profile-edit .profile-edit-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 150px;
  height: 150px;
}
.fi-profile-edit .RemoveImage {
  cursor: pointer;
}

.profile-image-edit-menu .mat-mdc-menu-item .mat-icon {
  font-size: 19px;
  line-height: 24px;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./Source/app/components/profile-edit/profile-edit.component.scss"],"names":[],"mappings":"AAEQ;EACI,mBAAA;EACA,UAAA;EACA,kBAAA;EACA,kBAAA;AADZ;AAGY;EACI,eAAA;AADhB;AAEgB;EACI,kBAAA;EACA,kCAAA;AAApB;AAIoB;EACI,kBAAA;AAFxB;AAMY;EACI,YAAA;EACA,aAAA;EACA,kBAAA;EACA,4BAAA;EACA,sCAAA;EACA,kCAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,oBAAA;AAJhB;AAKgB;EACI,mBAAA;AAHpB;AAKgB;EACI,uCAAA;AAHpB;AAKgB;EACI,sBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAHpB;AAOY;EACI,kBAAA;AALhB;AAMgB;EACI,kCAAA;AAJpB;AAQY;EACI,WAAA;EACA,YAAA;EACA,MAAA;EACA,OAAA;EACA,kBAAA;EACA,kBAAA;EACA,6BAAA;EACA,oBAAA;AANhB;AAQgB;EACI,mEAAA;AANpB;AASgB;EACI,mBAAA;AAPpB;AAWY;EACI,kBAAA;EACA,QAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,eAAA;AAThB;AAUgB;EACI,iBAAA;AARpB;AAUgB;EAEI,uCAAA;EACA,oDAAA;AATpB;AAWgB;EACI,SAAA;AATpB;AAWgB;EACI,aAAA;EACA,SAAA;EACA,2BAAA;AATpB;AAeQ;EACI,sBAAA;AAbZ;AAcY;EACI,YAAA;AAZhB;AAkBQ;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,YAAA;EACA,aAAA;AAhBZ;AAoBI;EACI,eAAA;AAlBR;;AAwBQ;EACI,eAAA;EACA,iBAAA;EACA,SAAA;AArBZ","sourcesContent":[".fi-profile-edit {\r\n    .new-profile-edit-layout {\r\n        .AddFileGroup {\r\n            margin: 0 auto 20px;\r\n            padding: 0;\r\n            position: relative;\r\n            width: fit-content;\r\n\r\n            .profile-edit-image {\r\n                cursor: pointer;\r\n                .UserImage {\r\n                    position: relative;\r\n                    box-shadow: 0 3px 11px 2px #cdcdcd;\r\n                }\r\n\r\n                &.locked-profile-icon.lockAfterCcmIcon {\r\n                    &:after {\r\n                        border-radius: 50%;\r\n                    }\r\n                }\r\n            }\r\n            .profile-image-upload-icon {\r\n                width: 150px;\r\n                height: 150px;\r\n                border-radius: 50%;\r\n                color: var(--fi-color-white);\r\n                background-color: var(--fi-color-dark);\r\n                box-shadow: 0 3px 11px 2px #cdcdcd;\r\n                text-align: center;\r\n                line-height: 150px;\r\n                cursor: pointer;\r\n                transition: all 0.2s;\r\n                &.square {\r\n                    border-radius: 10px;\r\n                }\r\n                &:hover {\r\n                    background-color: var(--fi-color-light);\r\n                }\r\n                .mat-icon {\r\n                    vertical-align: middle;\r\n                    font-size: 60px;\r\n                    width: 100%;\r\n                    height: 60px;\r\n                }\r\n            }\r\n\r\n            .fi-profile-icon {\r\n                position: relative;\r\n                .fi-profile-icon-img {\r\n                    box-shadow: 0 3px 11px 2px #cdcdcd;\r\n                }\r\n            }\r\n\r\n            .light-overlay {\r\n                width: 100%;\r\n                height: 100%;\r\n                top: 0;\r\n                left: 0;\r\n                position: absolute;\r\n                border-radius: 50%;\r\n                background-color: transparent;\r\n                transition: all 0.2s;\r\n\r\n                &.shown {\r\n                    background-color: var(--fi-background-color-extra-ligt-transparent);\r\n                }\r\n\r\n                &.square {\r\n                    border-radius: 10px;\r\n                }\r\n            }\r\n\r\n            .edit-profile-image-button {\r\n                position: absolute;\r\n                right: 0;\r\n                bottom: 10px;\r\n                border-radius: 50%;\r\n                width: 30px;\r\n                height: 30px;\r\n                line-height: 15px;\r\n                font-size: 18px;\r\n                .mat-icon {\r\n                    line-height: 30px;\r\n                }\r\n                &.centered,\r\n                &.top-right {\r\n                    background-color: var(--fi-color-white);\r\n                    box-shadow: 0 4px 10px 0 #0000001a;\r\n                }\r\n                &.top-right {\r\n                    top: 20px;\r\n                }\r\n                &.centered {\r\n                    bottom: -12px;\r\n                    left: 50%;\r\n                    transform: translateX(-50%);\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .AddFileGroup {\r\n        .fi-profile-icon {\r\n            vertical-align: middle;\r\n            &.lockAfterCcmIcon:after {\r\n                width: 160px;\r\n            }\r\n        }\r\n    }\r\n\r\n    fi-profile-edit {\r\n        .profile-edit-image {\r\n            position: absolute;\r\n            top: 0;\r\n            left: 0;\r\n            width: 150px;\r\n            height: 150px;\r\n        }\r\n    }\r\n\r\n    .RemoveImage {\r\n        cursor: pointer;\r\n    }\r\n}\r\n\r\n.profile-image-edit-menu {\r\n    .mat-mdc-menu-item {\r\n        .mat-icon {\r\n            font-size: 19px;\r\n            line-height: 24px;\r\n            margin: 0;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
